import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"min-height":"460px"} }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = {
  class: "table align-middle",
  style: {"table-layout":"fixed"}
}
const _hoisted_4 = { class: "bg-light" }
const _hoisted_5 = {
  class: "text-capitalize-first",
  style: {"width":"12%"}
}
const _hoisted_6 = {
  class: "text-capitalize-first",
  style: {"width":"18%"}
}
const _hoisted_7 = {
  class: "text-capitalize-first",
  style: {"width":"18%"}
}
const _hoisted_8 = {
  class: "text-capitalize-first",
  style: {"width":"11%"}
}
const _hoisted_9 = {
  class: "text-capitalize-first",
  style: {"width":"11%"}
}
const _hoisted_10 = {
  class: "text-capitalize-first",
  style: {"width":"13%"}
}
const _hoisted_11 = {
  class: "text-capitalize-first",
  style: {"width":"13%"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  colspan: "8",
  class: "text-center text-muted"
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_18 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "d-block text-muted mt-3" }
const _hoisted_22 = { class: "d-block text-muted" }
const _hoisted_23 = { class: "d-block text-muted" }
const _hoisted_24 = { class: "d-flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_SettingsHistoryModal = _resolveComponent("SettingsHistoryModal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_modal, {
      "dialog-class": "modal-xl",
      title: _ctx.helper.trans('labels.crossBorderRates'),
      modelValue: _ctx.modal,
      "footer-class": "d-flex justify-content-between",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modal = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalErrors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              key: error.message,
              class: "alert alert-danger mt-2 mb-0"
            }, _toDisplayString(error.message), 1))
          }), 128)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("table", _hoisted_3, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_4, [
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.crossBorderCurrency')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.crossBorderRateSource')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.crossBorderPayInRateSource')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.crossBorderAutomationGap')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.crossBorderOccupancyGap')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.crossBorderGapAmount')), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.crossBorderStep')), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("th", { style: {"width":"4%"} }, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.rows.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.crossBorderRatesEmpty')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'currency')
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            class: _normalizeClass(["multiselect-sm", parentProps.class]),
                            modelValue: row.currency,
                            "onUpdate:modelValue": ($event: any) => ((row.currency) = $event),
                            options: _ctx.currencyOptions(index),
                            "custom-label": (opt) => `${opt}`,
                            "select-label": "Select",
                            "deselect-label": "",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: true,
                            "internal-search": true,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "options-limit": 1000,
                            limit: 1000,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options", "custom-label"])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'source')
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            class: _normalizeClass(["multiselect-sm", parentProps.class]),
                            modelValue: row.source,
                            "onUpdate:modelValue": ($event: any) => ((row.source) = $event),
                            options: _ctx.rateSourceOptions(row.source),
                            "custom-label": (opt) => _ctx.rateSourceLabel(opt),
                            "select-label": "Select",
                            "deselect-label": "",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: true,
                            "internal-search": true,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "options-limit": 1000,
                            limit: 1000,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options", "custom-label"])
                        ]),
                        _: 2
                      }, 1032, ["errors"]),
                      _createElementVNode("small", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.crossBorderRateSourcePair', {currency: row.currency || _ctx.helper.trans('labels.currency')})), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'payInRateSource')
                      }, {
                        default: _withCtx((parentProps) => [
                          _createVNode(_component_Multiselect, {
                            class: _normalizeClass(["multiselect-sm", parentProps.class]),
                            modelValue: row.payInRateSource,
                            "onUpdate:modelValue": ($event: any) => ((row.payInRateSource) = $event),
                            options: _ctx.rateSourceOptions(row.payInRateSource),
                            "custom-label": (opt) => _ctx.rateSourceLabel(opt),
                            "select-label": "Select",
                            "deselect-label": "",
                            placeholder: "",
                            "open-direction": "bottom",
                            multiple: false,
                            searchable: true,
                            "internal-search": true,
                            "clear-on-select": false,
                            "close-on-select": true,
                            "options-limit": 1000,
                            limit: 1000,
                            "show-no-results": false,
                            "hide-selected": false
                          }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "options", "custom-label"])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'automationGap')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((row.automationGap) = $event),
                            type: "text",
                            class: _normalizeClass(["form-control form-control-sm", parentProps.class]),
                            "data-maska": "99.99",
                            "data-maska-tokens": "9:[0-9]:optional"
                          }, null, 10, _hoisted_15), [
                            [_vModelText, row.automationGap],
                            [_directive_maska]
                          ])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'gap')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((row.gap) = $event),
                            type: "text",
                            class: _normalizeClass(["form-control form-control-sm", parentProps.class]),
                            "data-maska": "99.99",
                            "data-maska-tokens": "9:[0-9]:optional"
                          }, null, 10, _hoisted_16), [
                            [_vModelText, row.gap],
                            [_directive_maska]
                          ])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'gapAmount')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((row.gapAmount) = $event),
                            type: "text",
                            class: _normalizeClass(["form-control form-control-sm", parentProps.class]),
                            "data-maska": "999999.99",
                            "data-maska-tokens": "9:[0-9]:optional",
                            placeholder: _ctx.helper.trans('labels.crossBorderAmountOffPlaceholder')
                          }, null, 10, _hoisted_17), [
                            [_vModelText, row.gapAmount],
                            [_directive_maska]
                          ])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_FormInputWrapper, {
                        errors: _ctx.errorsFor(index, 'step')
                      }, {
                        default: _withCtx((parentProps) => [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((row.step) = $event),
                            type: "text",
                            class: _normalizeClass(["form-control form-control-sm", parentProps.class]),
                            "data-maska": "999999.99",
                            "data-maska-tokens": "9:[0-9]:optional",
                            placeholder: _ctx.helper.trans('labels.crossBorderAmountOffPlaceholder')
                          }, null, 10, _hoisted_18), [
                            [_vModelText, row.step],
                            [_directive_maska]
                          ])
                        ]),
                        _: 2
                      }, 1032, ["errors"])
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _withModifiers(($event: any) => (_ctx.removeRow(index)), ["prevent"]),
                        class: "btn btn-sm btn-outline-danger"
                      }, _cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                      ]), 8, _hoisted_20)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addRow()), ["prevent"])),
            class: "btn btn-sm btn-outline-primary w-100 text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('labels.crossBorderRatesAddCurrency')), 1),
          _createElementVNode("small", _hoisted_21, _toDisplayString(_ctx.helper.trans('labels.crossBorderRatesDefaultHint')), 1),
          _createElementVNode("small", _hoisted_22, _toDisplayString(_ctx.helper.trans('labels.crossBorderRatesGapFallbackHint')), 1),
          _createElementVNode("small", _hoisted_23, _toDisplayString(_ctx.helper.trans('labels.crossBorderRatesAmountHint')), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          (_ctx.storeId)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)), ["prevent"])),
                class: "btn btn-outline-secondary btn-sm text-capitalize-first"
              }, _toDisplayString(_ctx.helper.trans('labels.history')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modal = false)),
            class: "btn btn-outline-secondary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.apply())),
          class: "btn btn-outline-primary btn-sm text-capitalize-first"
        }, _toDisplayString(_ctx.helper.trans('button.apply')), 1)
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_SettingsHistoryModal, {
      ref: "historyModal",
      "entity-type": "storeCrossBorder"
    }, null, 512)
  ], 64))
}